export default __webpack_public_path__ + "static/media/arrow.aaadbee4.svg";